import { AuthenticationChannelEvents } from '../../enums';
import { AuthenticationChannel } from './authentication-channel.class';
import { uuidv4 } from '../artifacts/uuidv4';
import { AuthenticatedWindow } from '../../actions/action-types';

const getURL = () => {
  const loc = window.location?.toString() ?? '';
  return new URL(loc);
};

export const getChannel = (url: URL) => {
  const channelDef = {
    browsingContext: uuidv4().slice(-10)
  };

  // Step 1: read parameter from the url
  // Step 2: if the parametere is not found on the url, fall back to
  //  sessionStorage.
  // Step 3: if no channel is available, a new channel will be created.
  const childChannel = url.searchParams.has('channel');
  if (childChannel) {
    return {
      ...channelDef,
      channelName: url.searchParams.get('channel') as string,
      child: true
    };
  }

  const fromSession = sessionStorage.getItem('channel');
  if (fromSession) {
    return {
      ...channelDef,
      channelName: fromSession as string,
      child: false
    };
  }

  return {
    ...channelDef,
    channelName: uuidv4(),
    child: false
  };
};

const channelDefinition = getChannel(getURL());
const authenticationChannel = new AuthenticationChannel(channelDefinition);
sessionStorage.setItem('channel', authenticationChannel.name);
// indicate that there is activity.
// this covers an edge case, where the user
// launches a new window, does not interact
// with it and then chooses to refresh.
authenticationChannel.postMessage({
  type: AuthenticatedWindow.ACTIVITY,
  payload: true,
  meta: {
    suppressRedux: true
  }
});

export { authenticationChannel };
